import { FC, ReactNode } from 'react'
import { FeaturedVenuesLive, FeaturedVenuesLiveType } from './Live'
import { FeaturedVenuesTag, FeaturedVenuesTagType } from './Tag'
import { FeaturedVenuesDate, FeaturedVenuesDateType } from './Date'

const FeaturedVenues: FC &
  FeaturedVenuesLiveType &
  FeaturedVenuesTagType &
  FeaturedVenuesDateType = (): ReactNode => <></>

FeaturedVenues.Live = FeaturedVenuesLive
FeaturedVenues.Tag = FeaturedVenuesTag
FeaturedVenues.Date = FeaturedVenuesDate

export default FeaturedVenues
